module.exports = __webpack_public_path__ + "img/close.7b34d2ce.svg";